/* src/app/layout/components/content/content.component.scss */
content {
  position: relative;
  display: flex;
  z-index: 1;
  flex: 1 0 auto;
}
content > *:not(router-outlet) {
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  min-width: 100%;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9sYXlvdXQvY29tcG9uZW50cy9jb250ZW50L2NvbnRlbnQuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbImNvbnRlbnQge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIHotaW5kZXg6IDE7XG4gICAgZmxleDogMSAwIGF1dG87XG5cbiAgICA+ICo6bm90KHJvdXRlci1vdXRsZXQpIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleDogMSAwIGF1dG87XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICBtaW4td2lkdGg6IDEwMCU7XG4gICAgfVxufVxuIl0sCiAgIm1hcHBpbmdzIjogIjtBQUFBO0FBQ0ksWUFBQTtBQUNBLFdBQUE7QUFDQSxXQUFBO0FBQ0EsUUFBQSxFQUFBLEVBQUE7O0FBRUEsUUFBQSxFQUFBLENBQUEsS0FBQTtBQUNJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTtBQUNBLFNBQUE7QUFDQSxhQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
